import React from 'react';
import { twMerge } from 'tailwind-merge';

import {
  ChevronLeft,
  Search,
  InformationCircle,
} from '@videoblocks/react-icons';

import { AISearchOptionConfig } from './aiSearchOptions';

const baseCls =
  'text-base rounded-lg px-2 py-1 border-0 text-white bg-black bg-opacity-15';

const ICONS: Record<AISearchOptionConfig['iconName'], React.ReactNode> = {
  chevronLeft: <ChevronLeft className="pt-1 w-4 h-4 fill-white" />,
  search: <Search className="pt-1 w-4 h-4 fill-white" />,
  informationCircle: <InformationCircle className="pt-1 w-4 h-4 fill-white" />,
  zap: (
    <svg
      className="pt-1"
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

interface AISearchOptionProps {
  label: string;
  iconName: AISearchOptionConfig['iconName'];
  href?: string;
  onClick?: () => void;
}

export default function AISearchOption({
  label,
  iconName,
  href,
  onClick,
}: AISearchOptionProps) {
  const icon = ICONS[iconName];

  if (href) {
    return (
      <a
        href={href}
        className={twMerge(baseCls, 'no-underline')}
        onClick={onClick}
      >
        {icon}
        {label}
      </a>
    );
  }

  return (
    <button type="button" onClick={onClick} className={baseCls}>
      {icon}
      {label}
    </button>
  );
}
